var path = 'pages/post.html';
var html = "<post data-post=post class=singlePost id={{post.id}}></post> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/post.html
// module id = 6/wH
// module chunks = 1